module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-error-2509d27bdad292f97a8c081e2853a4e3.svg";